/* unplugin-vue-components disabled */import script from "./MonthlyReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./MonthlyReport.vue?vue&type=script&lang=ts&setup=true"

import "./MonthlyReport.vue?vue&type=style&index=0&id=d3a3e1da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3a3e1da"]])

export default __exports__